<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useTheme } from '@/composables/useTheme'

// Initialize theme system - VueUse handles localStorage and data-theme attribute
useTheme()

onMounted(() => {
  // Theme system initialized automatically on composable import
  // VueUse sets data-theme attribute on HTML element and reads from localStorage
})
</script>

<style>
/* Gmail Classic Theme Integration - Feature: 009-css-modules-migration */
/* Import order: Variables first, then minimal global resets */
/* Theme CSS moved to CSS Modules - components import their own styles */
@import './assets/styles/global-resets.css';

/* Solarized Light Theme Variables (Legacy - kept for fallback) */
:root {
  /* Base tones */
  --sol-base03: #002b36;
  --sol-base02: #073642;
  --sol-base01: #586e75;
  --sol-base00: #657b83;
  --sol-base0: #839496;
  --sol-base1: #93a1a1;
  --sol-base2: #eee8d5;
  --sol-base3: #fdf6e3;

  /* Accent colors */
  --sol-yellow: #b58900;
  --sol-orange: #cb4b16;
  --sol-red: #dc322f;
  --sol-magenta: #d33682;
  --sol-violet: #6c71c4;
  --sol-blue: #268bd2;
  --sol-cyan: #2aa198;
  --sol-green: #859900;
}

/* Note: Global resets (*, body, #app) moved to global-resets.css */
/* Component-specific styles use CSS Modules starting from Phase 2 */
</style>
